/*
 * Datagrid component specific for Adalia M&E.
 */
import React from "react";
import Base from './base.jsx'; 
import { Mode, DataType, castDataType } from "../common.jsx";
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";

import { update } from "../../../helpers/index.js";
import Select from "../../common/Select.jsx";
import DatagridEditDialog from "../../datagrid/DatagridDialog.jsx"
import { FaIcon } from "../../common/Icons.jsx";
export default class AdaliaMEDatagridBase extends Base {
  static get CATEGORY() {
    return "question";
  }

  static get TYPE() {
    return "adalia_me_datagrid_base";
  }

  static icon() {
    return <i className="fa fa-th-large"></i>;
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: "field_default_label",
      description: "field_default_description",
    };
  }

  static defaultContent(language) {

    return Object.assign(super.defaultContent(language), {
      label: "label",
      description: "description",
      name: "field_" + Helpers.randomString(),
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      datagrids: [],
      showModal: false,
      context_name: ''
    };

    this.columnsRef = React.createRef();
    this.toggleModalVisibility = this.toggleModalVisibility.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.pdf) return;
  }

  toggleModalVisibility(visible) {
    if (this.props.mode == Mode.EDIT) return;

    this.setState({showModal: visible})
  }

  getColumns = () => {
    const { selectedDatagrid } = this.props.content
    const { datagrids } = this.state
    if (selectedDatagrid && datagrids.length > 0 && datagrids.filter((d) => d.id == parseInt(selectedDatagrid, 10)).length > 0){
      return datagrids.filter((d) => d.id == parseInt(selectedDatagrid, 10))[0]?.cols.map(c => Object.assign(c, {'value': c.id, 'label': c.name}));
    }
    return [];
  }

  onSave(answer){
    this.updateAnswer(answer)
    this.setState({showModal: false})
  }

  renderView() {
    if (this.props.pdf){
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
        <label>
          {this.getText("label")}
        </label>
        {this.descriptionText()}
        <div className='non-printable-component text-muted'>{I18n.t('non_printable_component_placeholder')}</div>
        </div>
      )
    }

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
          <span className="field-label">{this.getText('label')}</span>
        </label>
        {this.descriptionText()}
        {[Mode.FILL, Mode.EDIT].includes(this.props.mode) && 
          <div 
            className='border-dashed dark-bg d-flex align-items-center gap-1 p-1 text-color-light flex-dir-column cursor-pointer' 
            onClick = {(e) => { this.toggleModalVisibility(true) }}
          >
            <FaIcon type='table' style={{fontSize: '3rem', color: 'rgba(0,0,0,0.3)'}}/>
            <span>
              {I18n.t('modify_grid', {scope: 'fe'})}
            </span>
          </div>
        }
        
        <div className='d-flex justify-content flex-dir-column rounded p-1 mt-1' style={{ border: '2px solid rgba(0, 0, 0, 0.2)' }}
          onClick = {(e) => { e.preventDefault();this.toggleModalVisibility(true) }}
        >
          <div className='d-flex justify-content gap-1'>
            <span>{JSON.parse(this.getRawAnswer() || '[]').length + ' ' + I18n.t('rows_defined', {scope: 'fe'})}</span>
          </div>
          {this.props.mode == Mode.VIEW && <a href='#'>{I18n.t('click_to_view')}</a>}
        </div>
        {this.state.showModal ? (
          <DatagridEditDialog
            title={this.getText('label')}
            onClose={this.toggleModalVisibility}
            onSave={this.onSave}
            editable={[Mode.FILL, Mode.EDIT].includes(this.props.mode) && !this.isReadOnlyAnswer()}
            saveText={I18n.t('save')}
            datagridID={this.props.content.selectedDatagrid}
            visibleCols={this.props.content.visibleCols}
            rowData={this.getRawAnswer() ? JSON.parse(this.getRawAnswer()) : this.getRawAnswer()}
            contextName={this.state.context_name}
            queryParams={{programme_form_id: this.context.programmeFormId, project_id: this.context.projectId}}
           />
        ) : null}
        <input type="hidden" value={this.getRawAnswer()} name={this.fullFieldName()} />
      </div>
    );
  }

  updateAnswer(rows) {
    if (this.props.mode == Mode.FILL) {
      super.updateAnswer(JSON.stringify(rows));
    }
  }

  updateSettingsSelection(fieldName, newValue) {
    this.props.updateSettingsCallback(
      this.props.content.id,
      update(this.props.content, {
        [fieldName]: { $set: newValue }
      })
    );
  }

  renderSettings() {
    const { selectedDatagrid, visibleCols } = this.props.content
    const { datagrids } = this.state
    const allColumns = this.getColumns();

    return (
      <div>
        <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText("label")} onChange={this.updateSettings} />
        <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
        <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText("description")} onChange={this.updateSettings} />
        <Setting.TextField
          name="reportKey"
          label={I18n.t('field_report_key', {scope: 'fe'})}
          value={this.props.content.reportKey}
          description={I18n.t('field_report_key_description', {scope: 'fe'})}
          componentType={this.constructor.TYPE}
          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
        />
        {datagrids.length && (<><Setting.Dropdown 
            name="selectedDatagrid" 
            label={I18n.t('field_selected_datagrid', {scope: 'fe'})} 
            value={selectedDatagrid?.toString()} 
            onChange={this.updateSettings} 
            options={datagrids.map( d => [d.id, d.name] )}
        />
        <label className="w-100 mt-1">{I18n.t('field_datagrid_visible_cols', {scope: 'fe'})}</label>
        <Select
          name="visibleCols"
          defaultValue={allColumns.map(c => c.id)}
          value={visibleCols}
          isMulti={true}
          options={allColumns}
          onChange={(e) => this.updateSettingsSelection('visibleCols', e)}
          description={I18n.t('field_visible_columns_description', {scope: 'fe'})}
          selectAll={true}
          selectAllLabel={I18n.t('add_all_label', {scope: 'fe'})}
          autoComplete={this.getAutoComplete()}
        />

        </>)}
      </div>
    );
  }

  beforeUpdateSettings(content) {
    content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
    content.visibleCols = jQuery(this.refs.root).find('input[name="visibleCols"]').map(((i, e) => Number(e.value))).get();
    content.sumCol = jQuery(this.refs.root).find('input[name="sumCol"]').map((i, e) => e.value).get();
  }
}
